// The console has no control block forms, so error messages keep the raw form path.
export function getControlBlockTemplate(_params: unknown) {
  return {
    getComputedFields: (): Record<
      string,
      { formItem: { label?: string } }
    > => ({}),
  };
}
